// extracted by mini-css-extract-plugin
export default {"filesUpload":"PdfsUpload_filesUpload__b8W40"};